export default __webpack_public_path__ + "images/phone.svg?0d88c58608f8038dc181ca86fd9d6ae7";